import moment from 'moment';
import * as constAction from 'root/actionConstants';

export const clear = payload => ({
  type: constAction.REPORTES_CLEAR,
  payload,
});

export const setState = payload => ({
  type: constAction.REPORTES_SET_STATE,
  payload,
});

export const getReportes = (solucionadas, fecha, mensual = true, skip) => {
  let data = {
    type: constAction.REPORTES_GET,
    payload: { fecha, mensual, skip },
    epic: {
      url: 'reservasReporte/getAll',
      method: 'GET',
    },
  };
  if (solucionadas != null) data.payload.solucionadas = solucionadas;
  return data;
};

export const getCantidadReportes = () => ({
  type: constAction.REPORTES_CUANTOS_HAY,
  epic: {
    url: 'reservasReporte/cuantosHay',
    method: 'GET',
  },
});

export const solucionar = reporteId => ({
  type: constAction.REPORTES_SOLUCIONADO,
  payload: { reporteId },
  epic: {
    url: 'reservasReporte/solucionar',
    method: 'POST',
  },
});

export const solucionarCorrecto = reportes => ({
  type: constAction.REPORTES_SOLUCIONAR_MULTIPLE,
  payload: { reportes },
  epic: {
    url: 'reservasReporte/solucionarCorrectos',
    method: 'POST',
  },
});



// WEBPACK FOOTER //
// src/modules/reportes/action.js